import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useState } from 'react';
// material
import { styled } from '@mui/material/styles';
import { Box, Card, Stack, Link, Typography, Button} from '@mui/material';


// ----------------------------------------------------------------------

const ProductImgStyle = styled('img')({
  top: 0,
  width: '100%',
  height: '100%',
  position: 'absolute',
});

// ----------------------------------------------------------------------

ImagemCard.propTypes = {
  product: PropTypes.object,
};

export default function ImagemCard({ product }) {
  const [imagem, setImages] = useState(product)
  
  const removeImagem = () => {
    setImages();
  }

  return (
    <>
      {imagem && <Card>
        <Box sx={{ pt: '100%', position: 'relative' }}>
          <ProductImgStyle src={imagem.image} />
        </Box>
        <Stack spacing={2} alignItems="center" sx={{ p: 1}}>
          <Button onClick={removeImagem}>
            Remover
          </Button>
        </Stack>
      </Card>
      }
    </>
  );
} 
